import { Button, LottieAnimation, Space, Text } from '@billy/design-system'
import { ReactNode, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { usePageVisibility } from '../../../../hooks'

interface SuccessPageProps {
  onDoneClick: () => void
  headerLabel?: string
  bodyLabel?: string
  buttonLabel?: string
  customIcon?: ReactNode
}

export const SuccessPage = ({ onDoneClick, headerLabel, bodyLabel, buttonLabel, customIcon }: SuccessPageProps) => {
  const { t } = useTranslation()
  const { isVisible } = usePageVisibility()
  const lottieRef = useRef<any>(null)

  useEffect(() => {
    if (isVisible && lottieRef.current?.anim) {
      lottieRef.current.anim.play()
    }
  }, [isVisible])

  return (
    <>
      {customIcon || (
        <LottieAnimation
          ref={lottieRef}
          name="successIcon"
          options={{
            autoplay: false,
            loop: false,
          }}
          width={80}
          height={80}
        />
      )}
      <Space size="s24" />
      {headerLabel && (
        <>
          <Text variant="h1">{headerLabel}</Text>
          <Space size="s8" />
        </>
      )}
      {bodyLabel && <Text>{bodyLabel}</Text>}
      <Space size="s24" />
      <Button fullWidth onClick={onDoneClick}>
        {buttonLabel || t('done')}
      </Button>
    </>
  )
}
